<div class="capital-table-container" [ngClass]="{ 'segment-view': ucmgView === 'segmentView' }">
  @if (showLoader) {
  <div class="stk-table-loader segment-loader">
    <app-loader> </app-loader>
  </div>
  } @if (!ucmgListTable) {
  <div class="table-container" [ngClass]="TABLE_CONFIG['TABLE_CLASS']">
    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      class="mat-elevation-z8 child-table-class-sum"
      (matSortChange)="sortData($event)"
      multiTemplateDataRows
    >
      @for (col of COLUMNS; track col) {
      <ng-container [matColumnDef]="col.key">
        <ng-container>
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            [style.width]="col.width"
            [style.textAlign]="col.align"
            [style.padding]="col.padding"
          >
            @if (col['label'] != 'Actions') {
            <div>
              {{ col['label'] }}
              @if (col.key == 'Funding_Source' && col.filter) {
              <span>
                @if (!FundingSourceFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (FundingSourceFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </span>
              } @if (col.key == 'Funding_SegmentID' && col.filter) {
              <span>
                @if (!SegmentFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (SegmentFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </span>
              } @if (col.key == 'Funding_Segment' && col.filter) {
              <span>
                @if (!FundingSegmentFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (FundingSegmentFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </span>
              } @if (col.key == 'Funding_Owner' && col.filter) {
              <span>
                @if (!FundingOwnerFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (FundingOwnerFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="contextMenu"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </span>
              } @if (col.key == 'ucmg_count' && col.filter) {
              <span>
                @if (!ucmg_countFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="customNumbersFilter"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (ucmg_countFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="customNumbersFilter"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </span>
              } @if (col.key == 'flagged_ucmg_count' && col.filter) {
              <span>
                @if (!flagged_ucmg_countFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="customNumbersFilter"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (flagged_ucmg_countFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="customNumbersFilter"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </span>
              } @if (col.key == 'total_acap' && col.filter) {
              <span>
                @if (!totalACAPFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="customNumbersFilter"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (totalACAPFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="customNumbersFilter"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </span>
              } @if (col.key == 'total_OT' && col.filter) {
              <span>
                @if (!totalOTFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="customNumbersFilter"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (totalOTFilterApplied) {
                <span
                  (click)="filterDropdown(col); $event.stopPropagation()"
                  [matMenuTriggerFor]="customNumbersFilter"
                  #trigger="matMenuTrigger"
                >
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </span>
              }
              <mat-menu #contextMenu="matMenu">
                <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                  <input
                    matInput
                    type="text"
                    class="searchoption"
                    (keydown)="$event.stopPropagation()"
                    class="form-control filter-search-bar"
                    [(ngModel)]="searchTxt"
                    placeholder="Search"
                  />
                  <mat-selection-list
                    class="filter-list-container"
                    (selectionChange)="selectionChange($event, col)"
                    [disableRipple]="true"
                    [(ngModel)]="filValue"
                  >
                    @for (row of filterLists | search : searchTxt; track row) {
                    <mat-list-option checkboxPosition="before" [value]="row"> {{ row }}</mat-list-option>
                    }
                  </mat-selection-list>
                  <span
                    style="cursor:pointer; float: right;padding-right: 70px;color: #013b71 !important;"
                    class="small localApplyButton"
                    (click)="applyLocalFilter()"
                    >Apply</span
                  >
                  <span
                    style="cursor:pointer; float: right;padding-right: 22px;color: #013b71 !important;"
                    class="small localApplyButton"
                    (click)="clearLocalFilter(col)"
                    >Clear</span
                  >
                </div>
              </mat-menu>
              <ng-container class="custom-filter-popup">
                <mat-menu #customNumbersFilter="matMenu" panelClass="custom-numbers-menu-panel">
                  <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                    <app-custom-numbers-autofilter
                      #customNumbersAutoFilter
                      [column]="col.key"
                      [columnValues]="ucmgCountValues"
                      (applyNumberFilter)="numberFilterApply($event)"
                      (clearNumberFilter)="clearLocalFilter(col)"
                    ></app-custom-numbers-autofilter>
                  </div>
                </mat-menu>
              </ng-container>
              @if (col.isLastColumn && (FundingSourceFilterApplied || SegmentFilterApplied || FundingOwnerFilterApplied
              || FundingSegmentFilterApplied || ucmg_countFilterApplied || flagged_ucmg_countFilterApplied ||
              acapFilterApplied || totalACAPFilterApplied || totalOTFilterApplied)) {
              <span (click)="clearallFilter()">
                <i
                  title="Reset Filters"
                  class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
                ></i>
              </span>
              }
            </div>
            }
          </th>
        </ng-container>
        <ng-container>
          <td
            mat-cell
            *matCellDef="let element; let i = dataIndex"
            [style.textAlign]="col.align"
            [style.width]="col.width"
            [style.padding]="col.padding"
            [style.textAlign]="col.text_align"
          >
            @switch (col.key) { @case ('Actions') {
            <span>
              <div class="action-buttons">
                @if (!element.expand) {
                <button mat-icon-button (click)="expandDetailRow(element, true)">
                  <mat-icon class="actionItems-Expand addcircle material-icons mat-icon-no-color">
                    add_circle_outline</mat-icon
                  >
                </button>
                } @if (element.expand) {
                <button mat-icon-button (click)="collapseDetailRow(element)">
                  <mat-icon class="actionItems-Expand addcircle material-icons mat-icon-no-color">
                    remove_circle_outline</mat-icon
                  >
                </button>
                }
              </div>
            </span>
            } @case ('Funding_Owner') {
            <span>
              <div class="scrollable-height">
                <table class="scrollableLeft text-left">
                  <tbody>
                    @for (owner of element.Funding_Owner; track owner) {
                    <tr>
                      <td class="table-data-font table-data p-0" style="width:13%">{{ owner }}</td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </span>
            } @case ('ucmg_count') {
            <span>
              {{ element['ucmg_count'] }}
            </span>
            } @case ('flagged_ucmg_count') {
            <span>
              {{ element['flagged_ucmg_count'] }}
            </span>
            } @case ('total_acap') {
            <span>
              {{ element['total_acap'] | currency: 'USD':'symbol':'1.0-0' }}
            </span>
            } @case ('total_OT') {
            <span>
              {{ element['total_OT'] | currency: 'USD':'symbol':'1.0-0' }}
            </span>
            } @default {
            <span>
              @if (col.link) {
              <a [href]="getNavigationLink(col, element)" target="_blank" rel="noopener">
                {{ element[col.key] }}
              </a>
              } @else { @if (col.key === 'Funding_Segment') {
              <a href="javascript:void(0)" (click)="getNavLinkToUCMG(element)" rel="noopener">
                {{ element['Funding_Segment'] }}
              </a>
              } @else {
              {{ element[col.key] }}
              } }
            </span>
            } }
          </td>
        </ng-container>
      </ng-container>
      }
      <thead>
        <tr mat-header-row class="" *matHeaderRowDef="displayedColumns"></tr>
      </thead>
      <tbody>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="row-height"></tr>
      </tbody>
      <ng-container matColumnDef="nodata">
        <td mat-footer-row *matFooterCellDef [colSpan]="displayedColumns.length" style="text-align: center;">
          <div class="no-records-found">
            <div class="img-align">
              <img class="image-align" src="/assets/images/warning-icon.svg" />
            </div>
            <div class=" data-title">
              <div class="errorTitle">No Data Available</div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-footer-row [hidden]="dataSource && dataSource.data.length > 0" *matFooterRowDef="['nodata']"></tr>
    </table>
  </div>
  } @if (ucmgListTable) {
  <div class=" mat-elevation-z8 table-container-inside">
    <table
      #innerTables
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="sortData($event)"
      class="mat-elevation-z8 child-table-class"
      style="border-left: 0.03vw solid #c3c8cc"
    >
      @for (innerColumn of expanded_columns; track innerColumn) {
      <ng-container matColumnDef="{{ innerColumn.key }}">
        @if (innerColumn.key==='UCMG_ID_Name') {
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="table-light-background UCMG_ID_Name_Th"
          [disabled]="!innerColumn.sortable"
          [style.width]="innerColumn.width"
        >
          <span class="UCMG_ID_Name">
            {{ innerColumn.label }}
            @if (innerColumn.key == 'UCMG_ID_Name' && innerColumn.filter) {
            <span>
              @if (!ucmgIdNameFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="subFilters"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (ucmgIdNameFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="subFilters"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            }
            <mat-menu #subFilters="matMenu">
              <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <input
                  matInput
                  type="text"
                  class="searchoption"
                  (keydown)="$event.stopPropagation()"
                  class="form-control filter-search-bar"
                  [(ngModel)]="searchSubTxt"
                  placeholder="Search"
                />
                <mat-selection-list
                  class="filter-list-container"
                  (selectionChange)="selectionChange($event, innerColumn)"
                  [disableRipple]="true"
                  [(ngModel)]="filValue"
                >
                  @for (row of filterLists | search : searchSubTxt; track row) {
                  <mat-list-option checkboxPosition="before" [value]="row"> {{ row }}</mat-list-option>
                  }
                </mat-selection-list>
                <span
                  style="cursor:pointer; float: right; padding-right: 70px;"
                  class="small localApplyButton"
                  (click)="applyLocalFilter()"
                  >Apply</span
                >
                <span
                  style="cursor:pointer; float: right; padding-right: 22px;"
                  class="small localApplyButton"
                  (click)="clearLocalFilter(innerColumn)"
                  >Clear</span
                >
              </div>
            </mat-menu>
          </span>
        </th>
        } @if (innerColumn.key!=='UCMG_ID_Name') {
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="table-light-background"
          [style.width]="innerColumn.width"
          [style.padding]="innerColumn.paddingHeader"
          [disabled]="!innerColumn.sortable"
        >
          <span>
            {{ innerColumn.label }}
            @if (innerColumn.key == 'Funding_Segment' && innerColumn.filter) {
            <span>
              @if (!FundingSegmentFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="subFilters"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (FundingSegmentFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="subFilters"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'totalRunRate' && innerColumn.filter) {
            <span>
              @if (!totalRunRateFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (totalRunRateFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'ACAP' && innerColumn.filter) {
            <span>
              @if (!acapFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (acapFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'Optum_Tech_Labour' && innerColumn.filter) {
            <span>
              @if (!otlFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (otlFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'OT_Variance' && innerColumn.filter) {
            <span>
              @if (!otVarianceFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (otVarianceFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'Advisory_Service' && innerColumn.filter) {
            <span>
              @if (!advisoryServiceFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (advisoryServiceFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'Bussiness_Labour' && innerColumn.filter) {
            <span>
              @if (!businessLaborFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (businessLaborFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'Hardware_Software' && innerColumn.filter) {
            <span>
              @if (!hardwareSoftwareServiceApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (hardwareSoftwareServiceApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'Other_Chargebacks' && innerColumn.filter) {
            <span>
              @if (!otherChargebacksFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (otherChargebacksFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'Professional_Fees' && innerColumn.filter) {
            <span>
              @if (!professionalFeesFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (professionalFeesFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'Leader_OT_Allocation' && innerColumn.filter) {
            <span>
              @if (!leaderOTAllocationApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (leaderOTAllocationApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            } @if (innerColumn.key == 'Leader_OT_Actuals' && innerColumn.filter) {
            <span>
              @if (!leaderOTActualsFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
              </span>
              } @if (leaderOTActualsFilterApplied) {
              <span
                (click)="filterDropdown(innerColumn); $event.stopPropagation()"
                [matMenuTriggerFor]="customNumbersFilter"
                #trigger="matMenuTrigger"
              >
                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
              </span>
              }
            </span>
            }
            <mat-menu #subFilters="matMenu">
              <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <input
                  matInput
                  type="text"
                  class="searchoption"
                  (keydown)="$event.stopPropagation()"
                  class="form-control filter-search-bar"
                  [(ngModel)]="searchSubTxt"
                  placeholder="Search"
                />
                <mat-selection-list
                  class="filter-list-container"
                  (selectionChange)="selectionChange($event, innerColumn)"
                  [disableRipple]="true"
                  [(ngModel)]="filValue"
                >
                  @for (row of filterLists | search : searchSubTxt; track row) {
                  <mat-list-option checkboxPosition="before" [value]="row"> {{ row }}</mat-list-option>
                  }
                </mat-selection-list>
                <span
                  style="cursor:pointer; float: right; padding-right: 70px;"
                  class="small localApplyButton"
                  (click)="applyLocalFilter()"
                  >Apply</span
                >
                <span
                  style="cursor:pointer; float: right; padding-right: 22px;"
                  class="small localApplyButton"
                  (click)="clearLocalFilter(innerColumn)"
                  >Clear</span
                >
              </div>
            </mat-menu>
            <ng-container class="custom-filter-popup">
              <mat-menu #customNumbersFilter="matMenu" panelClass="custom-numbers-menu-panel">
                <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                  <app-custom-numbers-autofilter
                    #customNumbersAutoFilter
                    [column]="innerColumn.key"
                    [columnValues]="ucmgCountValues"
                    (applyNumberFilter)="numberFilterApply($event)"
                    (clearNumberFilter)="clearLocalFilter(innerColumn)"
                  ></app-custom-numbers-autofilter>
                </div>
              </mat-menu>
            </ng-container>
            @if (innerColumn.isLastColumn && (FundingSegmentFilterApplied || leaderOTAllocationApplied ||
            leaderOTActualsFilterApplied || ucmgNameFilterApplied || otlFilterApplied || totalRunRateFilterApplied ||
            ucmgIdNameFilterApplied || acapFilterApplied || totalOTFilterApplied || otVarianceFilterApplied ||
            advisoryServiceFilterApplied || businessLaborFilterApplied || hardwareSoftwareServiceApplied ||
            otherChargebacksFilterApplied || professionalFeesFilterApplied)) {
            <span (click)="clearallFilter()">
              <i
                title="Reset Filters"
                class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
              ></i>
            </span>
            }
          </span>
        </th>
        }
        <td
          mat-cell
          [style.width]="innerColumn.width"
          [style.padding]="innerColumn.padding"
          [style.textAlign]="innerColumn.textAlign"
          *matCellDef="let element"
        >
          <div>
            @switch (innerColumn.key) { @case ('Actions') {
            <span>
              <div class="action-buttons">
                @if (hasValidUCMGRole(element)) {
                <button mat-icon-button (click)="editUcmg(element)" title="Click to Edit UCMG">
                  <mat-icon
                    class="actionItems excelandinfo-Icon-font"
                    style="font-size: 1.1rem !important; cursor: pointer; color: #013B71; margin-bottom: 3px !important;"
                  >
                    create
                  </mat-icon>
                </button>
                } &nbsp; @if (isFundingAdmin(element)) {
                <div>
                  <mat-icon
                    class="mat-icon notranslate material-icons"
                    style="font-size: 1.1rem; cursor: pointer; color: #013B71;"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                    (click)="deleteDemand(element)"
                  >
                    delete
                  </mat-icon>
                </div>
                }
                <div>
                  <mat-icon
                    class="mat-icon notranslate material-icons"
                    style="font-size: 1.1rem; cursor: pointer; color: #013B71;"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                    (click)="viewComments(element)"
                  >
                    message
                  </mat-icon>
                </div>
              </div>
            </span>
            } @default {
            <span>
              @if (innerColumn.link) {
              <a [href]="getNavigationLink(innerColumn, element)" target="blank">
                {{ element[innerColumn.key] }}
              </a>
              } @if (innerColumn.currency) {
              <span>
                {{ formatMoney(element[innerColumn.key], innerColumn.decimals) }}
              </span>
              } @else { @if (innerColumn.key == 'UCMG_ID_Name') {
              <a class="link-click" (click)="optumTechModal(element)">{{ element[innerColumn.key] }}</a>
              } @else { @if (innerColumn.key =='allocationFlag') {
              <mat-icon [ngClass]="element[innerColumn.key]" class="custom-flag">circle</mat-icon>
              } @else {
              {{ element[innerColumn.key] }}
              } } }
            </span>
            } }
          </div>
        </td>
      </ng-container>
      }
      <thead>
        <tr mat-header-row *matHeaderRowDef="displayedChildColumns"></tr>
      </thead>
      <tbody>
        <tr mat-row *matRowDef="let row; columns: displayedChildColumns" class="example-element-row"></tr>
      </tbody>
      <ng-container matColumnDef="nodata">
        <td mat-footer-row *matFooterCellDef [colSpan]="displayedChildColumns.length" style="text-align: center;">
          <div class="no-records-found p-5">
            <div class="img-align">
              <img class="image-align" src="/assets/images/warning-icon.svg" />
            </div>
            <div class=" data-title">
              <div class="errorTitle">No Data Available</div>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-footer-row [hidden]="dataSource && dataSource.data.length > 0" *matFooterRowDef="['nodata']"></tr>
    </table>
  </div>
  }
  <app-modal [maximizable]="true" #OptumModal class="modal-demo move-top">
    <ng-container class="app-modal-header">
      <div style="display: flex;width: 100%;">
        <div class="otlTitle">
          <span class="fw-700 otlTitle">Optum Tech Labor Split for </span>{{ this.ucmgId }} - {{ this.ucmgName }} -
          {{ this.ucmgOwner }}
        </div>
        <div class="flex-container">
          <span
            class="popup-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon icon-size"
            matTooltipPosition="left"
            title="Info"
            (click)="showpopup()"
          >
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container class="app-modal-body">
      <app-optum-tech-labour
        [ucmgDisableData]="ucmgDisableData"
        [restrictionInvesterEdit]="restrictionInvesterEdit"
        [investmentStatus]="investmentStatus"
        (dataRefresh)="dataRefreshAfterSave($event)"
        [clearInputs]="clearInputs"
        [fiscalYear]="this.fiscalYear"
        [ucmgId]="this.ucmgId"
        [ucmgName]="this.ucmgName"
        [ucmgView]="ucmgView"
        [leadersDataLV]="leadersData"
        [availableOTL]="this.ucmgAvailableOT"
        [fundSegment]="fundSegment"
        [UCMG_Owner_MSID]="UCMG_Owner_MSID"
      ></app-optum-tech-labour>
    </ng-container>
  </app-modal>
  <app-modal (closeModal)="closeEditModal('editUcmg')" [maximizable]="true" #editUcmgModal class="modal-demo">
    <ng-container class="app-modal-header">
      <div style="display: flex;width: 100%;">
        <div style="width: 98%;">
          Edit UCMG <span>({{ editUcmgData?.fiscalYear }})</span>
        </div>
        <div style="display: flex; align-items: center;">
          <span
            class="popup-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon icon-size"
            matTooltipPosition="left"
            title="Info"
            (click)="showpopup()"
          >
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container class="app-modal-body p-0">
      @if (editUcmgData) {
      <app-edit-ucmg
        [yearList]="yearList"
        [editUcmgData]="editUcmgData"
        [isEditUcmg]="isEditUcmg"
        (editDataRefresh)="refreshEditdData($event)"
        [currentTable]="currentTable"
        [editUCMGUserRole]="editUCMGUserRole"
        [segData]="segData"
      ></app-edit-ucmg>
      }
    </ng-container>
  </app-modal>
  <app-modal [maximizable]="true" #viewCommentsModal class="modal-demo">
    <ng-container class="app-modal-header">
      <div style="display: flex;width: 100%;">
        <div style="width: 98%;">
          Comments
        </div>
        <div style="display: flex; align-items: center;">
          <span
            class="popup-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon icon-size"
            matTooltipPosition="left"
            title="Info"
            (click)="showpopup()"
          >
          </span>
        </div>
      </div>
    </ng-container>
    <ng-container class="app-modal-body p-0">
      @if (ucmgData) {
      <app-view-comments [ucmgData]="ucmgData"></app-view-comments>
      }
    </ng-container>
  </app-modal>
</div>
